/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ServiceActionTypeDtoFromJSON, ServiceActionTypeDtoToJSON, } from './';
export function ServiceActionTypeDtoGenericApiResponseFromJSON(json) {
    return ServiceActionTypeDtoGenericApiResponseFromJSONTyped(json, false);
}
export function ServiceActionTypeDtoGenericApiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'content': !exists(json, 'content') ? undefined : ServiceActionTypeDtoFromJSON(json['content']),
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}
export function ServiceActionTypeDtoGenericApiResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'content': ServiceActionTypeDtoToJSON(value.content),
        'errors': value.errors,
    };
}
